import { Link } from 'react-router-dom'

type BrandLogoProps = {
  to?: string
  className?: string
}

// Clickable Storyfy wordmark for app headers — returns to the public home page.
// Standardized across every route so the logo is always present and clickable.
// Getting back to the event list is DashboardButton's job, not the wordmark's.
const BrandLogo = ({ to = '/', className = '' }: BrandLogoProps) => (
  <Link
    to={to}
    aria-label="Storyfy — home"
    data-testid="brand-logo"
    className={`group inline-flex items-center gap-2 rounded-lg transition-opacity hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#ff4d8d]/40 ${className}`.trim()}
  >
    <span
      aria-hidden="true"
      className="flex h-8 w-8 -rotate-6 items-center justify-center rounded-xl bg-grad-juicy text-base leading-none text-white shadow-[0_8px_18px_rgba(255,77,141,0.4)] transition-transform duration-200 ease-spring group-hover:rotate-0 motion-reduce:transition-none"
    >
      ✦
    </span>
    <span className="font-display text-base font-extrabold tracking-tight text-[#1b1033] dark:text-[#f4f0ff]">
      Storyfy
    </span>
  </Link>
)

export default BrandLogo
